import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable max-len */
export const IconAddSolid = props => /*#__PURE__*/_jsx("svg", {
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 1024 1024",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M544 128v352H896v64H544V896h-64V544H128v-64h352V128h64z"
  })
});
//# sourceMappingURL=es/Icon/AddSolid.js.map